/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QrCodeAssignmentDto { 
    buildingIds: Array<string>;
    offsetLeft: number;
    offsetTop: number;
    includeVisible: boolean;
    includeHidden: boolean;
    design: QrCodeAssignmentDto.DesignEnum;
}
export namespace QrCodeAssignmentDto {
    export type DesignEnum = 'GEMA' | 'WR';
    export const DesignEnum = {
        Gema: 'GEMA' as DesignEnum,
        Wr: 'WR' as DesignEnum
    };
}


